/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChangeKind } from './ChangeKind';
import {
    ChangeKindFromJSON,
    ChangeKindFromJSONTyped,
    ChangeKindToJSON,
    ChangeKindToJSONTyped,
} from './ChangeKind';

/**
 * 
 * @export
 * @interface ProvisionChangeDto
 */
export interface ProvisionChangeDto {
    /**
     * 
     * @type {string}
     * @memberof ProvisionChangeDto
     */
    provisionId: string;
    /**
     * 
     * @type {ChangeKind}
     * @memberof ProvisionChangeDto
     */
    kind: ChangeKind;
    /**
     * 
     * @type {string}
     * @memberof ProvisionChangeDto
     */
    previousText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProvisionChangeDto
     */
    currentText?: string | null;
}



/**
 * Check if a given object implements the ProvisionChangeDto interface.
 */
export function instanceOfProvisionChangeDto(value: object): value is ProvisionChangeDto {
    if (!('provisionId' in value) || value['provisionId'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    return true;
}

export function ProvisionChangeDtoFromJSON(json: any): ProvisionChangeDto {
    return ProvisionChangeDtoFromJSONTyped(json, false);
}

export function ProvisionChangeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProvisionChangeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'provisionId': json['provisionId'],
        'kind': ChangeKindFromJSON(json['kind']),
        'previousText': json['previousText'] == null ? undefined : json['previousText'],
        'currentText': json['currentText'] == null ? undefined : json['currentText'],
    };
}

export function ProvisionChangeDtoToJSON(json: any): ProvisionChangeDto {
    return ProvisionChangeDtoToJSONTyped(json, false);
}

export function ProvisionChangeDtoToJSONTyped(value?: ProvisionChangeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'provisionId': value['provisionId'],
        'kind': ChangeKindToJSON(value['kind']),
        'previousText': value['previousText'],
        'currentText': value['currentText'],
    };
}

